import React from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { StaffManagementForm } from './StaffManagementForm';
import { Users } from 'lucide-react';

export const StaffRosterPage: React.FC = () => {
  const { tenantId, role, user } = useFirebase();
  const isSuperAdmin = user?.email?.toLowerCase() === 'admin@growezy.ai';
  const isManagerOrAdmin = role === 'admin' || role === 'manager' || role === 'owner' || isSuperAdmin;

  if (!isManagerOrAdmin || !tenantId) {
    return (
      <div className="p-8 text-center bg-gray-900 text-white min-h-screen">
        <h2 className="text-xl font-bold text-white">Access Restricted</h2>
        <p className="text-gray-400 mt-2">Only managers and administrators have permission to manage the staff roster.</p>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-gray-200 pb-6">
        <div>
          <div className="flex items-center gap-2 text-indigo-600 mb-1">
            <Users size={18} className="stroke-[2.5]" />
            <span className="text-xs font-black uppercase tracking-widest">Team Operations</span>
          </div>
          <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tight">Staff & Roster</h1>
          <p className="text-gray-500 text-sm mt-0.5">
            Manage your service team, job titles, hourly rates, and active shift rosters.
          </p>
        </div>
      </div>

      {/* Main Staff Management Form Component */}
      <StaffManagementForm tenantId={tenantId} />
    </div>
  );
};
